import { PaginatedChatsTable } from "./PaginatedChatsTable";

function ChatsTable() {
  return <PaginatedChatsTable showFilters defaultPageSize={20} />;
}

export { ChatsTable };
